<app-page-list [columns]="columns" [queryService]="service.query" [canInsert]="false">
  <div insert-form>
    <app-key-value-form [form]="insertForm" keyField="codice" valueField="descrizione"></app-key-value-form>
  </div>
</app-page-list>
